import { render } from "./Error.vue?vue&type=template&id=bee7acd2&scoped=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=bee7acd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bee7acd2"

export default script